import { useSelector } from 'react-redux'
import { selectHostConf, selectViewer } from '../../common/app/reducer'
import { getIsBulkOrderEnabled } from '../../common/bulkOrder'

/** Resolved bulk-order entitlement for the current viewer + hostConf. */
export const useIsBulkOrderEnabled = () => {
  const viewer = useSelector(selectViewer)
  const hostConf = useSelector(selectHostConf)
  return getIsBulkOrderEnabled(viewer, hostConf)
}
